var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box wrapper-payroll-employee" }, [
    _c(
      "h2",
      { staticClass: "title is-4 has-text-primary title-payroll-employee" },
      [_vm._v("\n    Datos del Empleado\n  ")]
    ),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                "label-for": "rfc-search",
                label: "Buscar/crear empleado por RFC"
              }
            },
            [
              _c(
                "BAutocomplete",
                {
                  attrs: {
                    id: "rfc-search",
                    value: _vm.text,
                    field: "rfc.rfc",
                    placeholder: "XAXX010101000",
                    data: _vm.employees,
                    loading: _vm.isFetching,
                    "open-on-focus": ""
                  },
                  on: { select: _vm.onSelect, input: _vm.onInput },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.getEmployeesByRfc($event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "media" }, [
                            _c("div", { staticClass: "media-left" }, [
                              _vm._v(
                                "\n                Número de Empleado: " +
                                  _vm._s(props.option.employedNumber) +
                                  "\n              "
                              )
                            ]),
                            _c("div", { staticClass: "media-content" }, [
                              _vm._v(
                                "\n                Nombre: " +
                                  _vm._s(props.option.name) +
                                  " "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                RFC: " +
                                  _vm._s(props.option.rfc.rfc) +
                                  " "
                              ),
                              _c("br"),
                              _c("small", [
                                _vm._v(
                                  "\n                  CURP: " +
                                    _vm._s(props.option.rfc.curp) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "RouterLink",
                        {
                          staticClass: "button is-text",
                          attrs: { to: { name: "PushEmployee" } }
                        },
                        [_c("span", [_vm._v("Crear empleado")])]
                      )
                    ],
                    1
                  ),
                  _c("template", { slot: "empty" }, [
                    _vm._v(
                      "\n            No se encontraron empleados con este RFC\n          "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC" } },
            [_c("BInput", { attrs: { value: _vm.rfc, disabled: "" } })],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "Nombre" } },
            [_c("BInput", { attrs: { value: _vm.name, disabled: "" } })],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }